export const linking = {
  config: {
    screens: {
      //marketing
      marketing: "",
      learnmore: "/learn-more",

      health: "/health",
      guestapp: "/guestapp",
      crewapp: "/crewapp",
      hospitality: "/hospitality",
      impactstudies: "/impactstudies",
      impactstudy: "/impactstudy/:type",
      aboutus: "/aboutus",

      settings: "/settings",
      plan: "/plan",

      //dashboard
      dashboard: "/dashboard",
      setup: "/setup",

      voicemail: "/voicemail",
      vvn: "/vvn",

      //auth
      auth: "/auth",
      passwordrecovery: "/auth/forgot",
      onboarding: "/onboarding",

      //vvn
      pinmanagement: "/pinmanagement/:type",
      pincdr: "/pincdr/:type",
      callingrate: "/callingrate",
      reportschedule: "/reportschedule",

      //pbx
      registration: "/registration",
      extension: "/extension",
      inboundroute: "/inboundroute",
      featurecode: "/featurecode",
      gateway: "/gateway/:gateway",
      ringgroup: "/ringgroup",
      number: "/number",
      voicemail: "/voicemail",
      voicemailmessage: "/voicemailmessage/:extension",
      hardware: "/hardware",
      ivr: "/ivr",
      dialplan: "/dialplan",
      recording: "/recording",
      pbxcdr: "/pbxcdr/:extension",

      //user
      user: "/user",
      userdetails: "/userdetails/:id",

      notfound: "*",
    },
  },
};

const routes = {
  //marketing
  marketing: "marketing",
  learnmore: "learnmore",
  health: "health",
  guestapp: "guestapp",
  crewapp: "crewapp",
  hospitality: "hospitality",
  impactstudies: "impactstudies",
  impactstudy: "impactstudy",
  aboutus: "aboutus",

  settings: "settings",
  plan: "plan",

  //dashboard
  dashboard: "dashboard",
  setup: "setup",

  voicemail: "voicemail",
  vvn: "vvn",

  //auth
  auth: "auth",
  passwordrecovery: "passwordrecovery",
  onboarding: "onboarding",

  //vvn
  pinmanagement: "pinmanagement",
  pincdr: "pincdr",
  callingrate: "callingrate",
  reportschedule: "reportschedule",

  //pbx
  registration: "registration",
  extension: "extension",
  inboundroute: "inboundroute",
  featurecode: "featurecode",
  gateway: "gateway",
  ringgroup: "ringgroup",
  number: "number",
  voicemail: "voicemail",
  voicemailmessage: "voicemailmessage",
  hardware: "hardware",
  ivr: "ivr",
  dialplan: "dialplan",
  recording: "recording",
  pbxcdr: "pbxcdr",

  // user
  user: "user",
  userdetails: "userdetails",

  notfound: "notfound",
};

export default routes;
